import React, { Suspense, lazy } from 'react'
import { AppProvider } from '@!/providers'
const BulkPurchaseTitles = lazy(() => import('@!/Store/BulkPurchaseTitles/containers/BulkPurchaseTitles'))

const BulkPurchaseTitlesApp = (props) => {
  return (
    <AppProvider>
      <Suspense fallback={null}>
        <BulkPurchaseTitles bookTitles={props.book_titles} />
      </Suspense>
    </AppProvider>
  )
}

export default BulkPurchaseTitlesApp
